// Navbar Scroll
let navbar = document.getElementById('wrapper-navbar');
let logoSvg = document.getElementById('svg-logo');
let lastKnownScrollPosition = 0;
let ticking = false;

function onScroll(scrollPos) {
  toggleFixedNav(scrollPos);
}

document.addEventListener('scroll', (e) => {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(() => {
      onScroll(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

function toggleFixedNav(scrollPos) {

    if (scrollPos > 250) {
        navbar.classList.add('fixed-nav');
        // logoSvg.setAttribute("viewBox", "0 0 188 66");

    } else {
        navbar.classList.remove('fixed-nav');
        // logoSvg.setAttribute("viewBox", "0 0 188 103.654");
    }

}
  

